const Currency_Formatter= new Intl.NumberFormat();
export const currencyFormat=(number)=>{
  return Currency_Formatter.format(number);
}